import { MoreHorizontal } from 'lucide-react'

import { Badge } from '@/components/ui/badge'

interface Props {
  values?: { id: string; name: string }[]
  length?: number
}

const HeaderBadges = ({ values, length = 5 }: Props) => {
  return (
    <div className="flex flex-wrap gap-1">
      {values &&
        values.slice(0, length).map((value) => <Badge key={value.id}>{value.name}</Badge>)}
      {values && values.length > length && (
        <MoreHorizontal className="my-auto ml-1 h-4 w-4 text-muted-foreground" />
      )}
    </div>
  )
}

export default HeaderBadges
